import { defineComponent, toRef, ref, computed, onMounted, createElementBlock, openBlock, createElementVNode, createBlock, createCommentVNode, Teleport, withKeys, normalizeClass, createVNode, toDisplayString, unref, renderSlot } from 'vue';
import { useBreakpoints } from './basler-components.es419.js';
import ShadowImage from './basler-components.es441.js';
import _sfc_main$2 from './basler-components.es201.js';
/* empty css                        */
import { BREAKPOINTS } from './basler-components.es435.js';
import _sfc_main$1 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = { class: "customer-account-layout" };
const _hoisted_2 = { class: "customer-account-layout__inner" };
const _hoisted_3 = { class: "customer-account-layout-panel__inner" };
const _hoisted_4 = { class: "customer-account-layout-panel__header" };
const _hoisted_5 = ["aria-expanded"];
const _hoisted_6 = { class: "visually-hidden" };
const _hoisted_7 = { class: "customer-account-layout-panel__trigger-btn-text" };
const _hoisted_8 = {
  id: "customer-account-layout-panel__main-01",
  class: "customer-account-layout-panel__main"
};
const _hoisted_9 = { class: "customer-account-layout-panel__main-outer" };
const _hoisted_10 = { class: "customer-account-layout-panel__main-inner" };
const _hoisted_11 = {
  key: 1,
  class: "customer-account-layout-panel"
};
const _hoisted_12 = { class: "customer-account-layout-panel__shadow" };
const _hoisted_13 = { class: "customer-account-layout__content" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CustomerAccountLayout",
  props: {
    navAriaLabel: {},
    mobileNavTitle: {},
    openBtnLabel: {},
    navItems: {}
  },
  emits: ["nav-click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const navItems = toRef(props, "navItems");
    const breakpoints = useBreakpoints(BREAKPOINTS);
    const isMounted = ref(false);
    const isOpen = ref(false);
    const teleportTarget = ref(null);
    const isDesktop = computed(() => {
      if (!isMounted.value) {
        return false;
      }
      return breakpoints.greaterOrEqual("lg").value;
    });
    const onLinkClick = (navItem) => {
      if (!isDesktop.value) {
        isOpen.value = false;
      }
      emit("nav-click", navItem);
    };
    const handleEscKey = (event) => {
      if (event.key === "Escape" && isOpen.value) {
        isOpen.value = false;
      }
    };
    onMounted(async () => {
      isMounted.value = true;
      if (document.querySelector("#page-header-secondary-bar")) {
        teleportTarget.value = "#page-header-secondary-bar";
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          navItems.value && !isDesktop.value && teleportTarget.value ? (openBlock(), createBlock(Teleport, {
            key: 0,
            to: teleportTarget.value,
            defer: ""
          }, [
            createElementVNode("div", {
              class: normalizeClass(["customer-account-layout-panel", { "is-open": isOpen.value }]),
              onKeydown: withKeys(handleEscKey, ["esc"])
            }, [
              createElementVNode("div", _hoisted_3, [
                createElementVNode("div", _hoisted_4, [
                  createElementVNode("button", {
                    type: "button",
                    class: "customer-account-layout-panel__trigger-btn",
                    "aria-expanded": isOpen.value ? "true" : void 0,
                    "aria-controls": "customer-account-layout-panel__main-01",
                    onClick: _cache[0] || (_cache[0] = ($event) => isOpen.value = !isOpen.value)
                  }, [
                    createElementVNode("span", _hoisted_6, toDisplayString(_ctx.openBtnLabel), 1),
                    createElementVNode("span", _hoisted_7, toDisplayString(_ctx.mobileNavTitle), 1),
                    createVNode(_sfc_main$1, { name: "arrow-down-bold" })
                  ], 8, _hoisted_5)
                ]),
                createElementVNode("div", _hoisted_8, [
                  createElementVNode("div", _hoisted_9, [
                    createElementVNode("div", _hoisted_10, [
                      createVNode(_sfc_main$2, {
                        "nav-aria-label": _ctx.navAriaLabel,
                        items: navItems.value,
                        onLinkClick
                      }, null, 8, ["nav-aria-label", "items"])
                    ])
                  ])
                ])
              ])
            ], 34)
          ], 8, ["to"])) : createCommentVNode("", true),
          navItems.value && isDesktop.value ? (openBlock(), createElementBlock("div", _hoisted_11, [
            createVNode(_sfc_main$2, {
              "nav-aria-label": _ctx.navAriaLabel,
              items: navItems.value,
              onLinkClick
            }, null, 8, ["nav-aria-label", "items"]),
            createElementVNode("div", _hoisted_12, [
              createVNode(unref(ShadowImage))
            ])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_13, [
            renderSlot(_ctx.$slots, "content")
          ])
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
